/* eslint-disable import/prefer-default-export */
import { UserRole } from '../types';

export const canEditLocation = (userRoleTitle: string | undefined): boolean => {
  if (userRoleTitle === undefined) {
    return false;
  }
  const editableRoles = [
    UserRole.SUPERUSER,
    UserRole.CAPTAIN,
    UserRole.WINGMAN,
  ];
  return !!userRoleTitle && editableRoles.includes(userRoleTitle as UserRole);
};

export const canStartStopStreams = (
  userRoleTitle: string | undefined
): boolean => {
  if (userRoleTitle === undefined) {
    return false;
  }
  const editableRoles = [UserRole.SUPERUSER, UserRole.CAPTAIN, UserRole.PILOT];
  return !!userRoleTitle && editableRoles.includes(userRoleTitle as UserRole);
};

export const canAcceptScheduledMission = (
  userRoleTitle: string | undefined
): boolean => {
  if (userRoleTitle === undefined) {
    return false;
  }
  const allowedRoles = [UserRole.SUPERUSER, UserRole.CAPTAIN, UserRole.PILOT];
  return !!userRoleTitle && allowedRoles.includes(userRoleTitle as UserRole);
};
